import { useMemo } from 'react';

import { useAuth } from '~/modules/auth/useAuth';

import { Ctx, PermissionKey, can } from '.';

export function usePermission(key: PermissionKey, ctx?: Ctx): boolean {
  const { currentUser } = useAuth();
  ctx = { user: currentUser, ...ctx };
  return useMemo(() => can(key, ctx), [key, ctx]);
}
